import {useCallback, useRef} from "react";
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import {createPublisherReturnState} from "./CampaignFilterState";

/**
 * Стабильная функция перехода в редактор с возвратом на текущий URL publisher.
 * Подписка на location остаётся в одном компоненте-списке, а не в каждой карточке кампании
 * (иначе каждое изменение URL, например ввод в поиск, перерисовывало все карточки).
 */
export default function useOpenCreator() {
    const navigate = useNavigate();
    const location = useLocation();
    const latest = useRef({navigate, location});
    latest.current = {navigate, location};

    return useCallback((path) => {
        const {navigate, location} = latest.current;
        navigate(path, {state: createPublisherReturnState(location)});
    }, []);
}
